import React,{useRef} from "react";
import {useIntersection} from "react-use";
import gsap from "gsap";
import "./Feature.css"
import applogo from "../../assets/Images/app-logo.png"
import worklogo from "../../assets/Images/training-logo.png"
import quizlogo from "../../assets/Images/quiz-logo.png"

const Features=()=>{
    const sectionRef = useRef(null);
    const intersection = useIntersection(sectionRef,{
      root:null,
      rootMargin:"0px",
      threshold:0.5
    })

    const fadeIn1 = (element)=>{
      gsap.to(element,1,{
        opacity:1,
        y:0,
        ease:"power4.out",
        stagger:{ amount:0.3 }
      })
    }

    const fadeOut = (element)=>{
      gsap.to(element,1,{
        opacity:0,
        y:40,
        ease:"power4.out",
        stagger:{ amount:0.3 }
      })
    }

    intersection && intersection.intersectionRatio < 0.4
        ? fadeOut(".fadeIn1")
        : fadeIn1(".fadeIn1")

    return(
        <div ref={sectionRef}>
            <div className="Features-title fadeIn1">
                <p>Features you'll love</p>
            </div>

            <div>

                <div ref={sectionRef} className="FeatureBox-box fadeIn1">
                    <img alt="" src={applogo}/>
                    <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://play.google.com/store/apps/details?id=com.udaan.recstudentportalV2"
                    >
                        <p>ANDROID APP</p>
                    </a>
                    <p id="sPara-p">
                        The only official app of Ramgarh Engineering College to
                        keep you updated, on Play Store.
                    </p>
                </div>

                <div ref={sectionRef} className="FeatureBox-box fadeIn1">
                    <img alt="" src={worklogo}/>
                    <p>WORKSHOPS</p>
                    <p id="sPara-p">
                        Technical Workshops by our team to keep you updated with industry knowledge.
                    </p>
                </div>

                <div ref={sectionRef} className="FeatureBox-box fadeIn1">
                    <img alt="" src={quizlogo}/>
                    <p>EVENTS</p>
                    <p id="sPara-p">
                        Mind-blowing events for students like Gusto, Quizathon & Coding contests.
                    </p>
                </div>

            </div>
        </div>
    )
}

export default Features;
